import { PollPinTextAnswer } from '@lessonup/pins-shared';
import { Card, fontSizeMap, lineHeightMap, SpaceBetween, spacing, styled } from '@lessonup/ui-components';
import React, { PropsWithChildren } from 'react';
import { ParsedTextTipTapViewer } from '../../../../../components/Tiptap/ParsedTextTipTapViewer';

export interface PollCardProps {
  index: number;
  answer: PollPinTextAnswer;
  active?: boolean;
  isInteractive?: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

export const PollTextAnswerCard: React.FC<
  PropsWithChildren<PollCardProps & { 'data-testid'?: string; className?: string }>
> = ({ index, answer, active, children, isInteractive, onClick, className, 'data-testid': dataTestId }) => {
  const shouldRenderAsButton = isInteractive && !active;

  return (
    <Card
      size="medium"
      active={active}
      showBoxShadow
      resizing="fixed"
      autoHeight
      as={shouldRenderAsButton ? 'button' : 'div'}
      className={className}
    >
      <SpaceBetween
        data-testid={dataTestId}
        onClick={onClick}
        direction="x"
        spacing={spacing.size16}
        alignItems="center"
        padding={spacing.size8}
      >
        <StyledAnswerIndex>{index + 1}</StyledAnswerIndex>
        <StyledAnswerWrapper direction="x" spacing={spacing.size8} alignItems="center">
          {children ? children : <ParsedTextTipTapViewer content={answer.text} />}
        </StyledAnswerWrapper>
      </SpaceBetween>
    </Card>
  );
};

const StyledAnswerWrapper = styled(SpaceBetween)`
  position: relative;
  width: 100%;
  font-size: ${fontSizeMap['bodyText'].medium};
  line-height: ${lineHeightMap['bodyText'].medium};

  p {
    margin: 0;
    padding: 0 8px;
    position: relative;
  }
`;

const StyledAnswerIndex = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;
